module.exports = "/images/smarty-says-offspring-1.png?0ad5a4c7dad27c6927f0b54187c4fe04";